(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-media-bullets"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Initialize each tabbed media wrapper independently
  document.querySelectorAll('.tabbed-media__wrapper').forEach((wrapper) => {
    
    // --- Pause all videos helper (scoped to this wrapper) ---
    function pauseAllVideos() {
      wrapper.querySelectorAll('.tabbed-media__media video').forEach(v => {
        v.pause();
        const icon = v.closest('.tabbed-media__media')?.querySelector('.tabbed-media__playicon');
        if(icon) icon.style.display = '';
      });
    }

    // --- Swiper initialization setup (must be before tabs) ---
    // Store swiper instances for each carousel
    const swiperInstances = new Map();

    function waitForSwiper(callback) {
      if (typeof Swiper !== 'undefined') {
        callback();
      } else {
        const checkInterval = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkInterval);
            callback();
          }
        }, 100);
      }
    }

    function initializeSwiper(root) {
      // Check if swiper already exists for this carousel
      if (swiperInstances.has(root)) {
        const existingSwiper = swiperInstances.get(root);
        if (existingSwiper && existingSwiper instanceof Swiper) {
          // Update existing swiper
          existingSwiper.update();
          existingSwiper.updateAutoHeight();
          return existingSwiper;
        }
      }

      const swiperEl = root.querySelector('.swiper-container, .swiper');
      if (!swiperEl) return null;

      const prevEl = root.querySelector('.tabbed-media__nav .prev');
      const nextEl = root.querySelector('.tabbed-media__nav .next');

      // Ensure all media items have swiper-slide class
      root.querySelectorAll('.swiper-wrapper > .tabbed-media__media').forEach(s => {
        s.classList.add('swiper-slide');
      });

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        autoHeight: true,
        navigation: { prevEl, nextEl },
        watchSlidesProgress: true,
        preventClicks: true,
        preventClicksPropagation: true
      });

      // Store the instance
      swiperInstances.set(root, swiper);

      // Pause hidden videos when sliding (scoped to this carousel)
      function pauseHiddenVideos() {
        root.querySelectorAll('video').forEach((v) => {
          const slide = v.closest('.swiper-slide');
          if (!slide || !slide.classList.contains('swiper-slide-active')) {
            if (!v.paused) v.pause();
            slide?.querySelector('.tabbed-media__playicon')?.classList.remove('is-playing');
          }
        });
      }
      swiper.on('slideChangeTransitionStart', pauseHiddenVideos);

      // Play button functionality (scoped to this carousel)
      root.querySelectorAll('.tabbed-media__playicon').forEach((btn) => {
        const video = btn.previousElementSibling;
        if (!(video && video.tagName === 'VIDEO')) return;

        btn.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            btn.classList.add('is-playing');
          } else {
            video.pause();
            btn.classList.remove('is-playing');
          }
        });

        video.addEventListener('play', () => btn.classList.add('is-playing'));
        video.addEventListener('pause', () => btn.classList.remove('is-playing'));
        video.addEventListener('ended', () => btn.classList.remove('is-playing'));
      });

      return swiper;
    }

    // --- Tabs: click to switch (scoped to this wrapper) ---
    const tabs = wrapper.querySelectorAll('.tabbed-media__tab');
    const contents = wrapper.querySelectorAll('[data-tab-content-index]');
    
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('tabbed-media__tab--active'));
        contents.forEach(c => c.style.display = 'none');
        tab.classList.add('tabbed-media__tab--active');
        const active = wrapper.querySelector(`[data-tab-content-index='${index}']`);
        if (active) active.style.display = 'grid';
        pauseAllVideos();
        
        // Update swiper when tab changes (after display change)
        setTimeout(() => {
          if (active) {
            const carousel = active.querySelector('.tabbed-media__carousel');
            if (carousel) {
              const swiper = swiperInstances.get(carousel);
              if (swiper && swiper instanceof Swiper) {
                swiper.update();
                swiper.updateAutoHeight();
              } else if (typeof Swiper !== 'undefined') {
                // Initialize if it doesn't exist yet
                initializeSwiper(carousel);
              }
            }
          }
        }, 50);
      });
    });

    // --- Video slides: click anywhere to play (scoped to this wrapper) ---
    wrapper.querySelectorAll('.tabbed-media__media').forEach(slide => {
      const video = slide.querySelector('video');
      if (!video) return;

      slide.style.cursor = 'pointer';
      const playIcon = slide.querySelector('.tabbed-media__playicon');

      const playVideo = () => {
        if (video.paused) {
          video.setAttribute('controls', 'controls');
          video.setAttribute('playsinline', '');
          // Pause other videos in this wrapper first
          wrapper.querySelectorAll('.tabbed-media__media video').forEach(v => { 
            if (v !== video) v.pause(); 
          });
          video.play().catch(()=>{});
        }
      };

      slide.addEventListener('click', (e) => {
        if (e.target.closest('.tabbed-media__nav, a, button')) return;
        playVideo();
      });

      video.addEventListener('play', () => { if (playIcon) playIcon.style.display = 'none'; });
      video.addEventListener('pause', () => { if (playIcon) playIcon.style.display = ''; });
      video.addEventListener('ended', () => {
        if (playIcon) playIcon.style.display = '';
        video.removeAttribute('controls');
      });
    });

    // Initialize all carousels when Swiper is available
    waitForSwiper(() => {
      wrapper.querySelectorAll('.tabbed-media__carousel').forEach((root) => {
        initializeSwiper(root);
      });
    });
  }); // End of wrapper forEach
})();

  } catch(e) { console.error(e); }
})();
})();
